import {createContext} from "react";

// Initialize context
const subMenuContext = createContext();

export default subMenuContext;
